import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import { Box, CircularProgress, ClickAwayListener, InputBase, Paper, Tooltip } from "@mui/material";
import { observer } from "mobx-react-lite";
import React, { useRef, useState } from "react";

interface FoodListProps {
    onSearch: (value: string) => void;
    onClear: () => void;
}

const FoodSearchBox: React.FC<FoodListProps> = observer(({ onSearch, onClear }) => {

    const textInputRef = useRef<HTMLInputElement>(null);

    const [text, setText] = useState('');

    const [showLoading, setShowLoading] = useState(false);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    const handleOnSearch = async (e: React.FormEvent) => {
        e.preventDefault();
        setShowLoading(true);

        if (text.length > 0 && text.length < 3) {
            setShowLoading(false);
            setIsTooltipOpen(true);
            return;
        }
        else if (isTooltipOpen) {
            setIsTooltipOpen(false);
        }

        if (textInputRef !== null && textInputRef.current !== null) {
            textInputRef!.current!.blur();
        }

        await onSearch(text);

        setShowLoading(false);
    };

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var value = event.target.value;
        setText(value);
    };

    const handleOnClear = async () => {
        setShowLoading(true);

        setIsTooltipOpen(false);
        setText('');

        onClear();

        setShowLoading(false);
    }

    var timerId: any = null;
    const handleOnFocus = () => {
        timerId = setTimeout(() => {
            scrollTo();
        }, 250);
    };

    const handleOnFocusOut = () => {
        clearTimeout(timerId);
    };

    const scrollTo = () => {
        if (textInputRef !== null && textInputRef.current !== null) {
            window.scrollTo({ top: textInputRef.current.getBoundingClientRect().top - 80, behavior: "smooth" });
        }
    };

    return (
        <ClickAwayListener onClickAway={() => setIsTooltipOpen(false)}>
            <Tooltip
                PopperProps={{
                    disablePortal: true,
                }}
                onClose={() => setIsTooltipOpen(false)}
                open={isTooltipOpen}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title="Unesi najmanje 3 slova"
            >
                <Paper
                    onClick={handleOnFocus}
                    onBlur={handleOnFocusOut}
                    component="form"
                    onSubmit={handleOnSearch}
                    sx={{
                        mb: 4,
                        backgroundColor: "#f9f9f9",
                        ":hover": {
                            boxShadow: (theme) => theme.shadows[6]
                        }
                    }}
                    elevation={8}
                >
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"center"}
                        p={1}
                        gap={1}>
                        {showLoading ? (
                            <CircularProgress size={22} />
                        ) : (
                            <SearchTwoToneIcon color="action" />
                        )}

                        <InputBase
                            inputRef={textInputRef}
                            placeholder="pretraži..."
                            value={text}
                            onChange={handleOnChange}
                            // onSubmit={handleOnSearch}
                            type="text"
                            fullWidth
                            sx={{
                                backgroundColor: "#f9f9f9"
                            }}
                        // inputProps={{ "aria-label": "search" }}
                        />

                        {text !== "" && <CloseTwoToneIcon onClick={handleOnClear} />}
                    </Box>
                </Paper>
            </Tooltip>
        </ClickAwayListener>
    );
});

export default FoodSearchBox;